var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7556 8.35556C14.0622 9.04889 14.0622 10.1511 14.7556 10.8444L18.1333 14.2222H1.77778C0.8 14.2222 0 15.0222 0 16C0 16.9778 0.8 17.7778 1.77778 17.7778H18.1333L14.7556 21.1556C14.0622 21.8489 14.0622 22.9511 14.7556 23.6444C15.4489 24.3378 16.5511 24.3378 17.2444 23.6444L23.6267 17.2622C24.32 16.5689 24.32 15.4489 23.6267 14.7556L17.2444 8.35556C16.5511 7.66222 15.4489 7.66222 14.7556 8.35556ZM32 28.4444H19.5556C18.5778 28.4444 17.7778 29.2444 17.7778 30.2222C17.7778 31.2 18.5778 32 19.5556 32H32C33.9556 32 35.5556 30.4 35.5556 28.4444V3.55556C35.5556 1.6 33.9556 0 32 0H19.5556C18.5778 0 17.7778 0.8 17.7778 1.77778C17.7778 2.75556 18.5778 3.55556 19.5556 3.55556H32V28.4444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.272ad6e3fa467c9cec938c973f8dd282.svg";
export { ForwardRef as ReactComponent };